/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorDetail
 */
export interface ErrorDetail {
    /**
     * Where the error occurred, e.g. 'body.items[3].tags' or 'path.thing-id'
     * @type {string}
     * @memberof ErrorDetail
     */
    location?: string;
    /**
     * Error message text
     * @type {string}
     * @memberof ErrorDetail
     */
    message?: string;
    /**
     * 
     * @type {any}
     * @memberof ErrorDetail
     */
    value?: any | null;
}

/**
 * Check if a given object implements the ErrorDetail interface.
 */
export function instanceOfErrorDetail(value: object): value is ErrorDetail {
    return true;
}

export function ErrorDetailFromJSON(json: any): ErrorDetail {
    return ErrorDetailFromJSONTyped(json, false);
}

export function ErrorDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'location': json['location'] == null ? undefined : json['location'],
        'message': json['message'] == null ? undefined : json['message'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function ErrorDetailToJSON(json: any): ErrorDetail {
    return ErrorDetailToJSONTyped(json, false);
}

export function ErrorDetailToJSONTyped(value?: ErrorDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'location': value['location'],
        'message': value['message'],
        'value': value['value'],
    };
}

